'use client'

import { useEffect } from 'react'
import Link from 'next/link'

interface ErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function Error({ error, reset }: ErrorProps) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <p className="text-5xl mb-4">⚠️</p>
        <h1 className="text-xl font-bold text-[#202833] mb-2">エラーが発生しました</h1>
        {/* サーバー側のエラーは本番で内容が伏せられ、英語の汎用文が入る。
            利用者には日本語の固定文を出し、問い合わせ用に digest だけ添える。
            実際のエラーは console と client_error_logs に記録される。 */}
        <p className="text-sm text-gray-400 mb-2">
          時間をおいてもう一度お試しください。解消しない場合は管理者にお問い合わせください。
        </p>
        <p className="text-xs text-gray-300 mb-8">
          {error.digest ? `問い合わせ番号: ${error.digest}` : ''}
        </p>
        <div className="flex items-center justify-center gap-3">
          <button
            onClick={reset}
            className="px-6 py-2.5 bg-[#202833] text-white text-sm font-medium rounded-xl hover:bg-[#2d3a47] transition-colors"
          >
            再試行する
          </button>
          <Link
            href="/reports"
            className="px-6 py-2.5 border border-gray-200 text-sm font-medium text-gray-600 rounded-xl hover:bg-gray-100 transition-colors"
          >
            ホームへ
          </Link>
        </div>
      </div>
    </div>
  )
}
